// @flow
import React from "react";

const SocialTrading = (props: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21.334"
    height="16"
    viewBox="0 0 21.334 16"
    {...props}
  >
    <path
      d="M10.667,43.812c1.87,0,3.325-1.94,3.325-3.947v-.629a3.326,3.326,0,1,0-6.649,0v.629C7.342,41.872,8.8,43.812,10.667,43.812Zm-6.661.649a2.28,2.28,0,0,0,2-2.133V41.261a2,2,0,1,0-4,0v1.067A2.3,2.3,0,0,0,4.006,44.461Zm11.971,2.667c0-.01,0-.02-.005-.031a2.571,2.571,0,0,0-.073-.369,0,0,0,0,0,0,0,2.281,2.281,0,0,0-.364-.745h0a4.282,4.282,0,0,0-1.431-1.2,1.578,1.578,0,0,0-.77-.306c-.368,0-.689.286-1.229.782h0l-.492.452c-.018.017-.548.766-.945.766s-.927-.749-.945-.766l-.492-.452h0c-.541-.5-.861-.782-1.229-.782a1.446,1.446,0,0,0-.77.306,5.011,5.011,0,0,0-1.43,1.2h0l0,0a2.281,2.281,0,0,0-.36.74l0,.007a2.641,2.641,0,0,0-.072.365c0,.012,0,.022-.005.034a3.7,3.7,0,0,0-.023.407c0,.016,0,2.92,0,2.933,0,.948.357,1.333,1.333,1.333h8c.984,0,1.333-.365,1.333-1.333,0-.014,0-2.918,0-2.933A3.75,3.75,0,0,0,15.977,47.129Zm1.362-2.667a2.28,2.28,0,0,0,2-2.133V41.261a2,2,0,1,0-4,0v1.067A2.3,2.3,0,0,0,17.34,44.461ZM1.517,45.905A2.885,2.885,0,0,0,0,48.47c0,.011,0,1.323,0,1.333,0,.968.325,1.333,1.333,1.333H4v-4l-.667-.667C2.628,45.848,2.034,45.611,1.517,45.905ZM4,47.136c.015.013,0-.317,0,0ZM21.334,48.47a2.885,2.885,0,0,0-1.517-2.565c-.517-.294-1.111-.057-1.817.565l-.667.667v4H20c1.008,0,1.333-.366,1.333-1.333C21.335,49.793,21.334,48.481,21.334,48.47Zm-4-1.333c0-.317-.015.013,0,0Z"
      transform="translate(0 -35.803)"
      fill="currentColor"
    />
  </svg>
);

export default SocialTrading;



// WEBPACK FOOTER //
// ./src/components/Icons/SocialTrading.js